import KeywordModalListItem from './KeywordModalListItem.vue';

export default KeywordModalListItem;
